import { AppBar, Container } from '@mui/material';

import { StyledToolBar, ToolbarShadowStyle } from '../ToolBar';

import type { ReactNode } from 'react';

export interface ScrollHeaderProps {
  transparent?: boolean;
  isScrolling?: boolean;
  children: ReactNode;
}

export function ScrollHeader({
  transparent,
  isScrolling,
  children,
}: ScrollHeaderProps): JSX.Element {
  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: 'transparent' }}>
      <StyledToolBar
        disableGutters
        transparent={transparent}
        scrolling={isScrolling}
      >
        <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {children}
        </Container>
      </StyledToolBar>
    </AppBar>
  );
  // return (
  //   <AppBar sx={{ boxShadow: 0, bgcolor: 'transparent' }}>
  //     <StyledToolBar disableGutters transparent={transparent} scrolling={isScrolling}>
  //       <Container
  //         sx={{
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'flex-start'
  //         }}
  //       >
  //         {children}
  //       </Container>
  //     </StyledToolBar>
  //     {isScrolling && <ToolbarShadowStyle/>}
  //   </AppBar>
  // );
}
